function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, JSON, Object, keydownProxyEl, searchFilter) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'mp-segment-menu': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-properties-menu", {
          "attrs": __vjadeStringifyAttrsIfObj({
            'open': $attr(`open`),
            'all-data-groups': $attr(`all-data-groups`),
            'allow-typecast': true,
            'data-group-id': $attr(`data-group-id`),
            'enable-workspace-filter-restrictions': $attr(`enable-workspace-filter-restrictions`),
            'event-names': JSON.stringify($attr(`event-names`)),
            'include-custom-properties': $attr(`include-custom-properties`),
            'project-has-cohorts': $attr(`project-has-cohorts`),
            'hide-events': $attr(`hide-events`),
            'project-has-people': $attr(`project-has-people`),
            'project-id': $attr(`project-id`),
            'property-combine-mode': `union`,
            'search-filter': searchFilter,
            'show-all-tab': true,
            'show-special-date-property': $attr(`show-special-date-property`),
            'show-special-dataset-property': $attr(`show-special-dataset-property`),
            'cohort-operation-type': `breakdown`,
            'selected': $helpers.getMenuSelection(),
            'user-id': $attr(`user-id`),
            'support-b2b-cohorts': $attr(`support-b2b-cohorts`),
            'inline-cohorts-override': $attr(`inline-cohorts-override`),
            'other-options': $attr(`other-group-by-options`),
            'workspace-id': $attr(`workspace-id`),
            'track-name': $attr(`track-name`),
          }),
          "hook": {
            insert: $helpers.onMenuInserted
          },
          "on": {
            deletecustomproperty: $helpers.propagateEvent,
            closedModal: $helpers.propagateEvent,
            select: $helpers.handleSelect,
            selectoption: $helpers.handleSelectOption,
            stagedproperty: $helpers.handleStagedProperty,
            track: $helpers.preventTracking,
            tooltipContextAction: $helpers.propagateEvent,
            tooltipContextEditDescription: $helpers.propagateEvent,
          },
          "props": {
            context: `segment`,
            keydownProxyEl,
            tooltipPositionParentElement: $component.tooltipPositionParentElement,
            useMultipleSelection: $helpers.isCohortSelection(),
          },
        }));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "keydownProxyEl" in locals ? locals.keydownProxyEl : typeof keydownProxyEl !== "undefined" ? keydownProxyEl : undefined, "searchFilter" in locals ? locals.searchFilter : typeof searchFilter !== "undefined" ? searchFilter : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;